import { BaseModel } from "sjs-base-model";
import InfoEstimatesModel from "stores/cerca-header/models/InfoEstimatesModel";

export default class BaseHeaderOptionModel extends BaseModel {
    public readonly href: string = "";
    public readonly name?: string = "";
    public readonly info?: InfoEstimatesModel = new InfoEstimatesModel({});

    constructor(data: Partial<BaseHeaderOptionModel>) {
        super();

        this.update(data);
    }
}
